<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-th-list"></i> {{ _('Johku Admin') }}</h3>
        </div>
        <div class="col-md-12">
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col" style="min-height: 60px">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="list-filter-col" style="min-height: 60px">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Display') }}</div>
              <select class="form-control" id="productTypeFilter" v-model="type">
                <option value="all">{{ _('All shops') }}</option>
                <option value="mobilepay-active">{{ _('Shops with MobilePay active') }}</option>
                <option value="mobilepay-pending">{{ _('Shops with MobilePay pending') }}</option>
                <option value="netvisor-enabled">{{ _('Shops with Netvisor enabled') }}</option>
                <option value="netvisor-configured">{{ _('Shops with Netvisor configured') }}</option>
                <option value="ropo-enabled">{{ _('Shops with Ropo enabled') }}</option>
                <option value="ropo-configured">{{ _('Shops with Ropo configured') }}</option>
                <option value="shipit">{{ _('Shops with Shipit') }}</option>
                <option value="epassi-enabled">{{ _('Shops with EPassi enabled') }}</option>
                <option value="edenred-enabled">{{ _('Shops with Edenred enabled') }}</option>
                <option value="gofinland-enabled">{{ _('Shops with GoFinland enabled') }}</option>
                <option value="retkipaikka-enabled">{{ _('Shops with RetkiPaikka enabled') }}</option>
                <option value="hotellinx-enabled">{{ _('Shops with Hotellinx enabled') }}</option>
                <option value="myallocator-enabled">{{ _('Shops with MyAllocator enabled') }}</option>
                <option value="channex-enabled">{{ _('Shops with Channex enabled') }}</option>
                <option value="bokun-enabled">{{ _('Shops with Bokun enabled') }}</option>
                <option value="custom-domain">{{ _('Shops with a Custom Domain') }}</option>
                <option value="custom-currency">{{ _('Shops with a Custom Currency') }}</option>
                <option value="legacy-igloohome-enabled">{{ _('Shops with Legacy Igloohome') }}</option>
                <option value="ratna-enabled">{{ _('Shops with Ratna enabled') }}</option>
                <option value="cookiebot-enabled">{{ _('Shops with Cookiebot enabled') }}</option>
                <option value="customcookiemanager-enabled">{{ _('Shops with Custom Cookie Manager enabled') }}</option>
                <option value="statisticsfinland-enabled">{{ _('Shops with Statistics Finland enabled') }}</option>
                <option value="seam-connected">{{ _('Shops with Seam connected') }}</option>
              </select>
            </div>
          </div>
          <button class="btn btn-success" @click="toggleColumnSelector"><i class="fa fa-fw fa-list"></i></button>
        </div>
        <div class="list-filter-col button-col filtercol" style="min-height: 60px">
          <button class="btn btn-success" type="button" v-on:click="downloadXlsx"><i class="fa fa-fw fa-download"></i> {{ _('Download Excel file') }}</button>
        </div>
      </div>
      <div v-if="isColumnSelectorVisible">
        <div class="row">
          <div class="col-md-12">
            <div class="column-selector-container p-3">
              <div class="column-selector-grid">
                <div v-for="column in fullTableOptions.columns.filter(c => c.field !== 'shopid')" :key="column.field" class="column-selector-item">
                  <div class="form-group">
                    <label :for="'col-' + column.field">
                      <input 
                      type="checkbox" 
                      :id="'col-' + column.field"
                      v-model="column.visible"
                      @change="updateColumns"
                    >
                      {{ column.title }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Datatable :url="shopsUrl" :search="search" :type-filter="type" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, DatetimePicker } from '#components'

export default {
  mixins: [components, formatters],
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    const dateFormat = this.$store.getters.dateFormat
    return {
      isColumnSelectorVisible: false,
      shops: [],
      search: '',
      type: 'all',
      fullTableOptions: {
        columns: [
        {
          title: _('Shop ID'),
          field: 'shopid',
          widthGrow: 5,
          responsive: 0,
          visible: true
        },
        {
          title: _('Status'),
          field: 'disabled',
          widthGrow: 3,
          formatter: this.adminShopStatusFormatter(),
          visible: true
        },
        {
          title: _('Company ID'),
          field: 'companyid',
          widthGrow: 3,
          visible: false
        },
        {
          title: _('Company'),
          field: 'companyname',
          widthGrow: 6,
          visible: true
        },
        {
          title: _('City'),
          field: 'companycity',
          widthGrow: 4,
          visible: true
        },
        {
          title: _('Created'),
          field: 'creationdate',
          widthGrow: 4,
          formatter: this.timestampFormatter(dateFormat),
          visible: true
        },
        {
          title: _('Email'),
          field: 'companyemail',
          widthGrow: 4,
          visible: true
        },
        {
          title: _('Domain'),
          field: 'shopdomain',
          widthGrow: 4,
          visible: false
        },
        {
          title: _('From template'),
          field: 'fromtemplate',
          widthGrow: 4,
          visible: false
        }
        ],
        initialSort: [{
          column: 'shopid',
          dir: 'asc'
        }],
        rowClick: async (e, row) => {
          $this.editRow(row)
        }
      },
    }
  },
  methods: {
    downloadXlsx () {
      const filters = []
      if (this.search) {
        filters.push({ field: 'search', type: 'like', value: this.search })
      }
      if (this.type) {
        filters.push({ field: 'type', type: '=', value: this.type })
      }
      let filterStr = ''
      if (filters.length) {
        filterStr = '&filters[]=' + filters.map(f => JSON.stringify(f)).join('&filters[]=')
      }
      window.open(this.baseDomain + this.shopId + '/admin/shops.xlsx?apikey=' + this.apiKey + filterStr)
    },
    updateColumns () {
      this.EventBus.$emit('redrawDataTable')
    },
    toggleColumnSelector () {
      this.isColumnSelectorVisible = !this.isColumnSelectorVisible
    },
    editRow (row) {
      let shopId = row.getCell('shopid').getValue()
      const shop = row.getData()
      this.editShop(shopId)
    },
    editShop (shopId, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'AdminShopDetails',
        title: this._('Shop') + ' ' + shopId,
        width: 6,
        data: {
          shopId: shopId
        },
        skipState
      })
    },    
    async load () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/admin/shops.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.shops = response.data
    },
    getStatus(shop) {
      if (parseInt(shop.locked)) {
        return '<i class="fa fa-fw fa-lock"></i> Locked'
      }
      if (parseInt(shop.notified)) {
        return '<i class="fa fa-fw fa-exclamation-triangle"></i> Notified'
      }
      if (!parseInt(shop.enabled)) {
        return '<i class="fa fa-fw fa-ban"></i> Disabled'
      }
      return '<i class="fa fa-fw fa-check"></i> Enabled'
    },
  },
  computed: {
    tableOptions () {
      return {
        ...this.fullTableOptions,
        columns: this.fullTableOptions.columns.filter(c => c.visible)
      }
    },
    shopsUrl () {
      return this.baseDomain + this.shopId + '/admin/shops.json?apikey=' + this.apiKey
    }
  },
  components: {
    Datatable,
    DatetimePicker
  },
  created () {
    // this.load()
  }
}
</script>

<style scoped>
.action-create {
  color: #4f792b;
}
.action-delete{
  color: #cd1e1a;
}
.action-update {
  color: #00b8d4;
}
.action-refresh {
  color: gray;
}
.column-selector-container {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.column-selector-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.column-selector-item {
  padding: 0.5rem;
}

.column-selector-item:hover {
  background: #e9ecef;
  border-radius: 4px;
}

.form-check-label {
  cursor: pointer;
  user-select: none;
}
</style>